module.exports = __webpack_public_path__ + "img/電気回路_6_1.c26a1d33.png";